import CustomObject from './CustomObject.js'

export default class Mirror extends CustomObject
{
    constructor(modelPath, position, id, rotation) {
        super(modelPath, position, id, rotation);
        this.type = "mirror";
        if(this.position.y === 0) {
            this.position.y = 0.5;
        }

        this.collisionAllowed = true;
        this.snappingAllowed = true;
        this.axesMove = [true, true, true]; // x, y, z
    }
}